"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var Grouping = (function () {
    function Grouping() {
    }
    Grouping.groupCruisesByRoute = function (cruises) {
        return _.groupBy(cruises, function (cruise) { return cruise.itinerary[0].name; });
    };
    return Grouping;
}());
exports.Grouping = Grouping;
//# sourceMappingURL=grouping.js.map